__turbopack_context__.v({
  "card": "StatCard-module__Fh3tKq__card",
  "content": "StatCard-module__Fh3tKq__content",
  "icon": "StatCard-module__Fh3tKq__icon",
  "label": "StatCard-module__Fh3tKq__label",
  "shimmer": "StatCard-module__Fh3tKq__shimmer",
  "skeleton": "StatCard-module__Fh3tKq__skeleton",
  "value": "StatCard-module__Fh3tKq__value",
});
